module.exports = __webpack_public_path__ + "img/error_case_2.32a5d7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/error_case_2.svg
// module id = 06kO
// module chunks = 1